export const replaceSubdomainToProd = (url: string) =>
  url ? url.replace('https://media.hml.gokonfetti.com/', 'https://media.gokonfetti.com/') : url
